import { TipTapBlockEditor } from "@circle-react-shared/uikit/TipTapBlockEditor";

interface DisplayTiptapContentProps {
  tiptapBody: any;
  variant?: "default" | "compact";
}

export const DisplayTiptapContent = ({
  tiptapBody,
  variant = "default",
}: DisplayTiptapContentProps) => (
  <TipTapBlockEditor
    readOnly
    value={tiptapBody.body}
    sgidToObjectMap={tiptapBody.sgids_to_object_map}
    inlineAttachments={tiptapBody.inline_attachments}
    openInternalLinksInCurrentTab
    disabledExtensions={["cta"]}
    shouldSupportTables
    variant={variant}
  />
);
